import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const MoveableObjectContext = /*#__PURE__*/createContext(undefined);
export const MoveableObjectProvider = ({
  closeButtonStyleOverrides,
  children
}) => {
  const memoizedValue = useMemo(() => {
    return {
      closeButtonStyleOverrides
    };
  }, [closeButtonStyleOverrides]);
  return /*#__PURE__*/_jsx(MoveableObjectContext.Provider, {
    value: memoizedValue,
    children: children
  });
};

/**
 * Provides the context for the `MoveableObject` component.
 * Note: The context is only available when the `MoveableObject` component is rendered as an ancestor.
 * @returns MoveableObjectContext - The context for the `MoveableObject` component.
 * @returns MoveableObjectContext.closeButtonStyleOverrides - Style overrides to be applied to the `CloseButton` component.
 */
export const useMoveableObjectContext = () => {
  const moveableObjectContext = useContext(MoveableObjectContext);
  return moveableObjectContext;
};